"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
require("./SFTabs.css");
var moduleName = 'simplifeye-tabs';
var SFTabs = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, tabs = _a.tabs, selectedTab = _a.selectedTab, onChange = _a.onChange;
    var handleChangeTab = function (event, newValue) { return onChange(newValue); };
    return (react_1.default.createElement(core_1.Tabs, { classes: { root: moduleName + " " + className, indicator: moduleName + "__indicator" }, value: selectedTab, onChange: handleChangeTab }, tabs.map(function (tab, index) { return (react_1.default.createElement(core_1.Tab, { classes: { root: moduleName + "__tab", selected: moduleName + "__tab--selected" }, key: tab.label + "-" + index, label: tab.label, disabled: tab.disabled })); })));
};
exports.default = SFTabs;
